<template>
  <v-container v-if="loading == false">
    <QuickNavigation :fileData="fileData" :routeHistory="$route" />

    <div v-if="!!du && !!fileData">
      <v-stepper v-model="step" vertical>
        <v-stepper-step
          :complete="step > 1"
          step="1"
          :color="step > 1 ? 'success' : 'primary'"
        >
          Get Credit Report or Uploading BCA Form
          <small></small>
        </v-stepper-step>

        <v-stepper-content :step="1">
          <div
            v-if="
              !fileData.embeddedDocs.some(
                (x) =>
                  x.documentTypeCode == 'BorrowersCert' &&
                  x.description.includes('BCA')
              )
            "
          >
            <div class="text-right my-2">
              <v-btn @click="downloadBCA" color="error" outlined
                >BCA Form Download
                <v-icon>mdi-download</v-icon>
              </v-btn>
            </div>
            <v-alert type="info">
              You must submit a borrower certification & authorization form to
              perform this task.
            </v-alert>
            <vue-dropzone
              ref="bcaFormDropzone"
              id="bcaFormDropzone"
              :options="bcaFormDropzoneOptions"
              @vdropzone-file-added="vdropzoneFileAdded"
              @vdropzone-error-multiple="submitPackageVDropzoneErrorMultiple"
              @vdropzone-success-multiple="
                submitPackageVDropzoneSuccessMultiple
              "
              @vdropzone-complete-multiple="vdropzoneCompleteMultiple"
              @vdropzone-queue-complete="
                submitPackageVDropzoneQueueCompleteMultiple
              "
            ></vue-dropzone>
            <v-btn
              class="my-2"
              block
              elevation="0"
              color="primary"
              @click="$refs.bcaFormDropzone.processQueue()"
              >Upload</v-btn
            >
          </div>
          <div v-else>
            <v-alert type="success" dismissible>
              Borrower certification & authorization form has been successfully
              submitted.
            </v-alert>
            <br />
            <v-autocomplete
              v-model="selectedCreditAgency"
              :items="creditAgencies"
              :item-text="
                (item) =>
                  `${item.displayName} ${
                    fileData.customValues.some((x) =>
                      x.name.startsWith(`${item.codeName}.CreditRefNo`)
                    )
                      ? '✅'
                      : ''
                  }`
              "
              :item-value="(item) => item"
              label="Select Credit Company"
              hide-details="auto"
              auto-select-first
              outlined
              :rules="[required]"
              dense
            ></v-autocomplete>
            <br />
            <v-row v-if="!!selectedCreditAgency.displayName">
              <v-col
                v-for="(credit, index) in du.credits"
                :key="`app` + index"
                cols="12"
                md="6"
              >
                <v-card v-if="!!selectedCreditAgency" class="pa-4" outlined>
                  <div class="d-flex">
                    <div class="text-h6">
                      {{ selectedCreditAgency?.displayName }}
                    </div>
                    <v-spacer></v-spacer>
                    <div class="text-body-1"># {{ index + 1 }}</div>
                  </div>
                  <div class="text-h6">Name: {{ credit.nameOnReport }}</div>
                  <div>
                    <v-icon v-if="!!credit.creditRefNo" color="success"
                      >mdi-check-circle-outline</v-icon
                    >
                    <span>Credit Reference #: </span>
                    <span v-if="!!credit.creditRefNo">{{
                      credit.creditRefNo
                    }}</span>
                    <span v-else class="error--text">Not found</span>
                  </div>
                  <v-divider class="my-3"></v-divider>
                  <div class="text-right">
                    <v-btn
                      @click="showCreditSubmitForm(credit.applicationId)"
                      color="info"
                      elevation="0"
                    >
                      Get Credit Report
                    </v-btn>
                  </div>
                </v-card>
              </v-col>
            </v-row>
            <br />
            <v-checkbox
              v-model="selectedCreditAgency.confirmedBCA"
              label="By checking this box, I confirm that I have reviewed and verified the uploaded borrower's authorization form for accuracy and completeness."
            ></v-checkbox>
            <v-btn
              v-if="
                fileData.customValues.filter((x) =>
                  x.name.startsWith(
                    `${selectedCreditAgency.codeName}.CreditRefNo`
                  )
                ).length >= fileData.applications.length &&
                selectedCreditAgency.confirmedBCA
              "
              class="my-1"
              color="primary"
              elevation="0"
              @click="step = 2"
            >
              Continue
            </v-btn>
            <div v-else class="error--text text-h6">
              <v-btn disabled>Continue</v-btn>
              <!-- *No credit report found. -->
            </div>
          </div>
        </v-stepper-content>

        <v-stepper-step
          :complete="step > 2"
          step="2"
          :color="step > 2 ? 'success' : 'primary'"
        >
          Import Liabilities from Credit Report
        </v-stepper-step>

        <v-stepper-content step="2">
          <v-row
            v-for="(item, index) in du.importDebtStatus"
            :key="`import-liabilities-` + index"
          >
            <v-col cols="12" lg="6" xl="3">
              <v-card outlined>
                <v-alert :type="item.checked ? 'success' : 'warning'">
                  *Please ensure all the data is imported
                </v-alert>
                <div class="text-center">
                  <div class="text-h6">
                    {{ index + 1 }}. {{ item.nameOnReport }}
                  </div>
                  <v-btn
                    outlined
                    color="secondary"
                    class="ma-4"
                    @click="
                      showImportLiabilities(
                        item.nameOnReport,
                        item.applicationId
                      )
                    "
                  >
                    Manage liabilties
                  </v-btn>
                </div>
              </v-card>
            </v-col>
          </v-row>
          <div class="d-flex my-2">
            <v-btn text @click="step -= 1"> Back </v-btn>
            <!-- <div
              v-if="
                du.importDebtStatus != null &&
                du.importDebtStatus.some((x) => x.checked == false)
              "
            >
              <v-btn disabled> Continue </v-btn>
            </div> -->
            <v-btn color="primary" @click="step += 1" elevation="0">
              Continue
            </v-btn>
          </div>
        </v-stepper-content>

        <v-stepper-step
          :complete="step > 3"
          step="3"
          :color="step > 3 ? 'success' : 'primary'"
        >
          Update Employer Information
          <!-- Link HELOC or Mortgage debt to REO (Real Estate Owned) -->
        </v-stepper-step>

        <v-stepper-content step="3">
          <v-container fluid>
            <v-radio-group
              v-model="tempBorrowerId"
              row
              hide-details="auto"
              dense
            >
              <div
                v-for="app in fileData.applications"
                :key="`borrower-employer-radio-${app.applicationId}`"
                class="d-flex"
              >
                <v-radio
                  :label="app.borrower.fullName"
                  :value="app.borrower.borrowerId"
                ></v-radio>
                <v-radio
                  v-if="!!app.coBorrower"
                  :label="app.coBorrower.fullName"
                  :value="app.coBorrower.borrowerId"
                ></v-radio>
              </div>
            </v-radio-group>
          </v-container>
          <v-container v-if="!!tempBorrowerId && !!fileData.employers" fluid>
            <div class="text-right">
              <v-btn
                color="primary"
                text
                @click="
                  showEmployerEditor({
                    fileDataId: fileData.fileDataId,
                    borrowerId: tempBorrowerId,
                  })
                "
              >
                + Add Employment
              </v-btn>
            </div>
            <v-sheet class="my-2" color="primary" dark>
              Primary/Current Employment
            </v-sheet>
            <v-simple-table class="mt-4 table--bordered" dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th style="width: 20%">Name</th>
                    <th style="width: 20%">Address</th>
                    <th style="width: 15%">How Long</th>
                    <th style="width: 10%">Position</th>
                    <th style="width: 10%">Self Emp.</th>
                    <th style="width: 10%">Special Ref</th>
                    <th style="width: 10%">Income</th>
                    <th style="width: 5%"></th>
                  </tr>
                </thead>
                <tbody class="text-center">
                  <tr
                    v-for="(employer, index) in fileData.employers.filter(
                      (x) => x.borrowerId == tempBorrowerId && x.status == 2
                    )"
                    :key="'current-employer-storedDoc-' + index"
                  >
                    <td>
                      <div
                        class="overflow-ellipsis"
                        style="width: 100px"
                        :title="employer.name"
                      >
                        {{ employer.name }}
                      </div>
                    </td>
                    <td>
                      <div
                        class="overflow-ellipsis"
                        style="width: 100px"
                        :title="`${employer.street}, ${employer.city}, ${employer.state} ${employer.zip}`"
                      >
                        {{
                          `${employer.street}, ${employer.city}, ${employer.state} ${employer.zip}`
                        }}
                      </div>
                    </td>
                    <td>
                      Since {{ employer.dateFrom | moment("MMM DD yyyy") }}
                    </td>
                    <td>{{ employer.position }}</td>
                    <td>{{ employer.selfEmp == 0 ? "No" : "Yes" }}</td>
                    <td>{{ employer.isSpecialRelationship }}</td>
                    <td>{{ employer.moIncome | currency() }}</td>
                    <td>
                      <div class="d-flex">
                        <v-btn
                          color="primary"
                          icon
                          x-small
                          @click="showEmployerEditor(employer)"
                          ><v-icon>mdi-pencil</v-icon></v-btn
                        >
                      </div>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <v-sheet class="my-2" color="primary" dark>
              Secondary/Additional Employment
            </v-sheet>
            <v-simple-table class="mt-4 table--bordered" dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th style="width: 20%">Name</th>
                    <th style="width: 20%">Address</th>
                    <th style="width: 15%">How Long</th>
                    <th style="width: 10%">Position</th>
                    <th style="width: 10%">Self Emp.</th>
                    <th style="width: 10%">Special Ref</th>
                    <th style="width: 10%">Income</th>
                    <th style="width: 5%"></th>
                  </tr>
                </thead>
                <tbody class="text-center">
                  <tr
                    v-for="(employer, index) in fileData.employers.filter(
                      (x) => x.borrowerId == tempBorrowerId && x.status == 1
                    )"
                    :key="'current-employer-storedDoc-' + index"
                  >
                    <td>
                      <div
                        class="overflow-ellipsis"
                        style="width: 100px"
                        :title="employer.name"
                      >
                        {{ employer.name }}
                      </div>
                    </td>
                    <td>
                      <div
                        class="overflow-ellipsis"
                        style="width: 100px"
                        :title="`${employer.street}, ${employer.city}, ${employer.state} ${employer.zip}`"
                      >
                        {{
                          `${employer.street}, ${employer.city}, ${employer.state} ${employer.zip}`
                        }}
                      </div>
                    </td>
                    <td>
                      Since {{ employer.dateFrom | moment("MMM DD yyyy") }}
                    </td>
                    <td>{{ employer.position }}</td>
                    <td>{{ employer.selfEmp == 0 ? "No" : "Yes" }}</td>
                    <td>{{ employer.isSpecialRelationship }}</td>
                    <td>{{ employer.moIncome | currency() }}</td>
                    <td>
                      <v-btn
                        color="primary"
                        icon
                        x-small
                        @click="showEmployerEditor(employer)"
                        ><v-icon>mdi-pencil</v-icon></v-btn
                      >
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <v-sheet class="my-2" color="primary" dark>
              Former Employment Employment
            </v-sheet>
            <v-simple-table class="mt-4 table--bordered" dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th style="width: 20%">Name</th>
                    <th style="width: 20%">Address</th>
                    <th style="width: 15%">How Long</th>
                    <th style="width: 10%">Position</th>
                    <th style="width: 10%">Self Emp.</th>
                    <th style="width: 10%">Special Ref</th>
                    <th style="width: 10%">Income</th>
                    <th style="width: 5%"></th>
                  </tr>
                </thead>
                <tbody class="text-center">
                  <tr
                    v-for="(employer, index) in fileData.employers.filter(
                      (x) => x.borrowerId == tempBorrowerId && x.status == 0
                    )"
                    :key="'current-employer-storedDoc-' + index"
                  >
                    <td>
                      <div
                        class="overflow-ellipsis"
                        style="width: 100px"
                        :title="employer.name"
                      >
                        {{ employer.name }}
                      </div>
                    </td>
                    <td>
                      <div
                        class="overflow-ellipsis"
                        style="width: 100px"
                        :title="`${employer.street}, ${employer.city}, ${employer.state} ${employer.zip}`"
                      >
                        {{
                          `${employer.street}, ${employer.city}, ${employer.state} ${employer.zip}`
                        }}
                      </div>
                    </td>
                    <td>
                      Since {{ employer.dateFrom | moment("MMM DD yyyy") }}
                    </td>
                    <td>{{ employer.position }}</td>
                    <td>{{ employer.selfEmp == 0 ? "No" : "Yes" }}</td>
                    <td>{{ employer.isSpecialRelationship }}</td>
                    <td>{{ employer.moIncome | currency() }}</td>
                    <td>
                      <v-btn
                        color="primary"
                        icon
                        x-small
                        @click="showEmployerEditor(employer)"
                        ><v-icon>mdi-pencil</v-icon></v-btn
                      >
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-container>
          <!-- <div
            v-for="(app, index) in fileData.applications"
            :key="`app-reos-` + index"
          >
            <v-sheet v-if="app.borrower" class="my-2" outlined>
              <div class="text-h6">{{ app.borrower.fullName }}</div>
              <v-divider></v-divider>
              <v-simple-table dense>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th>Address</th>
                      <th>Value</th>
                      <th>Status</th>
                      <th>Usage</th>
                      <th>T&I / HOD</th>
                      <th>Gross Rent</th>
                    </tr>
                  </thead>
                  <tbody
                    v-for="reo in app.borrower.reos"
                    :key="`reo-` + reo.reoid"
                  >
                    <tr>
                      <td>{{ reo.street }}</td>
                      <td>{{ reo.marketValue | currency("$", 2, 1) }}</td>
                      <td>
                        {{
                          $store.state.mstCodeEnums[`reoStatus${reo.reostatus}`]
                        }}
                      </td>
                      <td>
                        {{
                          $store.state.mstCodeEnums[
                            `reoCurrentUsageType${reo.currentUsageType}`
                          ]
                        }}
                      </td>
                      <td>{{ reo.taxes | currency("$", 2, 1) }}</td>
                      <td>{{ reo.grossRentalIncome | currency("$", 2, 1) }}</td>
                    </tr>
                    <tr>
                      <td colspan="8">
                        <v-expansion-panels focusable>
                          <v-expansion-panel
                            v-for="linkedDebt in fileData.debts.filter(
                              (x) => x.reoid == reo.reoid
                            )"
                            :key="`linked-debt-` + linkedDebt.debtId"
                          >
                            <v-expansion-panel-header>
                              [{{ linkedDebt.accountNo }}] -
                              {{ linkedDebt.name }}
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <div>
                                Debt Type:{{
                                  $store.state.mstCodeEnums[
                                    `debtType${linkedDebt.debtType}`
                                  ]
                                }}
                              </div>
                              <div>
                                Address: {{ linkedDebt.street }},
                                {{ linkedDebt.city }}, {{ linkedDebt.state }}
                                {{ linkedDebt.zip }}
                              </div>
                              <div>
                                Monthly Payment:
                                {{ linkedDebt.moPayment | currency("$", 2, 1) }}
                              </div>
                              <div>
                                Unpaid Balance:
                                {{ linkedDebt.unpaidBal | currency("$", 2, 1) }}
                              </div>
                              <div>
                                Payments Left: {{ linkedDebt.paymentsLeft }}
                              </div>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </v-expansion-panels>
                        <div class="text-center">
                          <v-btn
                            @click="
                              showLinkLiabilities(reo.reoid, app.borrower)
                            "
                            text
                            >+Link liabilities</v-btn
                          >
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-sheet>
            <v-sheet v-if="app.coBorrower" class="my-2" outlined>
              <div class="text-h6">{{ app.coBorrower.fullName }}</div>
              <v-divider></v-divider>
              <v-simple-table dense>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th>Address</th>
                      <th>Value</th>
                      <th>Status</th>
                      <th>Usage</th>
                      <th>T&I / HOD</th>
                      <th>Gross Rent</th>
                    </tr>
                  </thead>
                  <tbody
                    v-for="reo in app.coBorrower.reos"
                    :key="`reo-` + reo.reoid"
                  >
                    <tr>
                      <td>{{ reo.street }}</td>
                      <td>{{ reo.marketValue }}</td>
                      <td>{{ reo.reostatus }}</td>
                      <td>{{ reo.currentUsageType }}</td>
                      <td>{{ reo.taxes }}</td>
                      <td>{{ reo.grossRentalIncome }}</td>
                    </tr>
                    <tr>
                      <td colspan="8">
                        <ul>
                          <li
                            v-for="linkedDebt in fileData.debts.filter(
                              (x) => x.reoid == reo.reoid
                            )"
                            :key="`linked-debt-` + linkedDebt.debtId"
                          >
                            {{ linkedDebt.name }}
                          </li>
                        </ul>
                        <div class="text-center">
                          <v-btn
                            @click="
                              showLinkLiabilities(reo.reoid, app.coBorrower)
                            "
                            text
                            >+Link liabilities</v-btn
                          >
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-sheet>
          </div>-->
          <div>
            <v-btn @click="step -= 1" text> Back </v-btn>
            <v-btn color="primary" @click="step = 4" elevation="0">
              Continue
            </v-btn>
          </div>
        </v-stepper-content>

        <v-stepper-step
          :complete="step > 4"
          step="4"
          :color="step > 4 ? 'success' : 'primary'"
        >
          Desktop Underwriter
        </v-stepper-step>

        <v-stepper-content step="4">
          <v-form ref="submitDuForm">
            <v-row v-if="!!selectedCreditAgency">
              <v-col cols="12">
                <v-sheet color="primary white--text text-body-1">
                  Credit information
                </v-sheet>
              </v-col>
              <v-col
                cols="12"
                md="6"
                v-for="credit in du.credits.filter(
                  (x) => x.codeName == selectedCreditAgency.codeName
                )"
                :key="`du-credit-${credit.nameOnReport}`"
              >
                <v-card outlined>
                  <v-card-title>
                    <div>
                      <span class="info--text">{{
                        selectedCreditAgency.displayName
                      }}</span>
                    </div>
                  </v-card-title>
                  <v-card-text>
                    <div>
                      {{ credit.nameOnReport }}
                    </div>
                    <div>
                      Credit Reference #:
                      {{ credit.creditRefNo }}
                    </div>
                  </v-card-text>
                  <!-- <v-card-actions class="text-right">
                    <v-spacer></v-spacer>
                    <v-btn
                      color="info"
                      elevation="0"
                      @click="showEmbeddedDoc(credit.creditReportPdf)"
                      >View</v-btn
                    >
                  </v-card-actions> -->
                </v-card>
              </v-col>
            </v-row>
            <div class="d-flex">
              <v-btn @click="step -= 1" text> Back </v-btn>
              <v-spacer></v-spacer>
              <!-- <v-btn
                color="warning"
                class="mx-1"
                elevation="0"
                @click="submitDU"
              >
                Validate
              </v-btn> -->
              <v-btn
                color="primary"
                class="mx-1"
                elevation="0"
                @click="submitDU"
              >
                Run DU
              </v-btn>
            </div>
          </v-form>
        </v-stepper-content>

        <v-stepper-step :complete="step == 5" step="5" :color="'success'">
          Desktop Underwriter Result
        </v-stepper-step>

        <v-stepper-content step="5">
          <div v-if="!!du.result">
            <v-row class="text-center">
              <v-col cols="12" md="3">
                <div class="text-h6">
                  CaseFile ID: {{ du.result.caseFileID }}
                </div>
              </v-col>
              <v-col cols="12" md="3">
                <div class="text-h6">
                  Result:
                  <span
                    :class="
                      du.result.recommendation == 'Error'
                        ? 'error--text'
                        : 'success--text'
                    "
                    >{{ du.result.recommendation }}</span
                  >
                </div>
              </v-col>
              <v-col cols="12" md="3">
                <v-btn
                  class="mx-2"
                  elevation="0"
                  outlined
                  color="error"
                  @click="downloadHtml(du.result.findingHtml)"
                >
                  Download DU Finding
                  <v-icon>mdi-download</v-icon>
                </v-btn>
              </v-col>
              <v-col cols="12" md="3">
                <v-btn
                  color="primary"
                  @click="step -= 3"
                  class="mx-2"
                  elevation="0"
                  text
                  >Re-run the DU</v-btn
                >
              </v-col>
            </v-row>
            <!-- <div class="text-right">
            <v-btn
              color="primary"
              @click="downloadHtml(du.result.findingHtml)"
              outlined
            >
              Download DU Findings
              <v-icon right> mdi-download </v-icon>
            </v-btn>
          </div>
          <div v-if="du.result != null">
            <v-sheet height="500" class="overflow-y-auto my-2" outlined>
              <div v-html="du.result.findingHtml"></div>
            </v-sheet>
          </div> -->
            <!-- <v-btn
              color="info"
              x-large
              elevation="0"
              outlined
              @click="openFinding(du.result.findingHtml)"
              >View DU Finding</v-btn
            > -->
          </div>
        </v-stepper-content>
      </v-stepper>

      <v-dialog v-model="runCredit.dialog" max-width="1200" persistent>
        <v-card>
          <v-form ref="runCreditForm">
            <v-card-title class="text-body-1 grey lighten-2">
              <div>Credit - {{ runCredit.creditProvider }}</div>
              <v-spacer></v-spacer>
              <v-btn @click="runCredit.dialog = false" x-small icon light>
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text v-if="!!runCredit.borrower">
              <v-row dense>
                <v-col cols="12" md="6">
                  <v-select
                    label="Request Type"
                    v-model="runCredit.creditRequestType"
                    :items="creditReportOptions"
                    item-text="displayName"
                    item-value="codeValue"
                    :rules="[requiredNotAllowZero]"
                    dense
                    outlined
                    hide-details="auto"
                  ></v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-if="runCredit.creditRequestType == 'Reissue'"
                    label="Credit Reference No"
                    v-model="runCredit.creditRefNo"
                    :rules="[required]"
                    dense
                    outlined
                    hide-details="auto"
                    clearable
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-sheet class="pb-3" outlined>
                    <div class="text-h6">Borrower</div>
                    <v-row>
                      <v-col cols="12" md="4">
                        <v-text-field
                          label="First Name"
                          v-model="runCredit.borrower.firstName"
                          :rules="[required]"
                          dense
                          outlined
                          hide-details="auto"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field
                          label="Middle Name"
                          v-model="runCredit.borrower.middleName"
                          dense
                          outlined
                          hide-details="auto"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field
                          label="Last Name"
                          v-model="runCredit.borrower.lastName"
                          :rules="[required]"
                          dense
                          outlined
                          hide-details="auto"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="12">
                        <v-text-field
                          label="Residence Street"
                          v-model="runCredit.borrower.currentResidence.street"
                          :rules="[required]"
                          dense
                          outlined
                          hide-details="auto"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field
                          label="City"
                          v-model="runCredit.borrower.currentResidence.city"
                          :rules="[required]"
                          dense
                          outlined
                          hide-details="auto"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-select
                          v-model="runCredit.borrower.currentResidence.state"
                          :items="$store.state.selectList.state"
                          item-text="displayName"
                          item-value="key"
                          label="State"
                          :rules="[requiredNotAllowZero]"
                          outlined
                          dense
                          hide-details="auto"
                          clearable
                        ></v-select>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field
                          label="Zipcode"
                          v-model="runCredit.borrower.currentResidence.zip"
                          :rules="[required, zipcode]"
                          dense
                          outlined
                          hide-details="auto"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field
                          label="SSN"
                          v-model="runCredit.borrower.ssn"
                          v-mask="$store.state.mask.ssn"
                          :rules="[required, ssn]"
                          dense
                          readonly
                          background-color="readonly"
                          outlined
                          hide-details="auto"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field
                          label="Day of Birth (yyyy-mm-dd)"
                          v-model="runCredit.borrower.dob"
                          v-mask="$store.state.mask.date2"
                          placeholder="yyyy-mm-dd"
                          :rules="[required]"
                          dense
                          outlined
                          hide-details="auto"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-select
                          label="Marital Status"
                          v-model="runCredit.borrower.maritalStatus"
                          :items="maritalStatusItems"
                          item-text="displayName"
                          item-value="codeValue"
                          :rules="[requiredNotAllowZero]"
                          dense
                          outlined
                          hide-details="auto"
                        ></v-select>
                      </v-col>
                    </v-row>
                  </v-sheet>
                </v-col>
                <v-col v-if="!!runCredit.coBorrower" cols="12" md="6">
                  <v-sheet class="pb-3" outlined>
                    <div class="text-h6">Co-Borrower</div>
                    <v-row>
                      <v-col cols="12" md="4">
                        <v-text-field
                          label="First Name"
                          v-model="runCredit.coBorrower.firstName"
                          :rules="[required]"
                          dense
                          outlined
                          hide-details="auto"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field
                          label="Middle Name"
                          v-model="runCredit.coBorrower.middleName"
                          dense
                          outlined
                          hide-details="auto"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field
                          label="Last Name"
                          v-model="runCredit.coBorrower.lastName"
                          :rules="[required]"
                          dense
                          outlined
                          hide-details="auto"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="12">
                        <v-text-field
                          label="Residence Street"
                          v-model="runCredit.coBorrower.currentResidence.street"
                          :rules="[required]"
                          dense
                          outlined
                          hide-details="auto"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field
                          label="City"
                          v-model="runCredit.coBorrower.currentResidence.city"
                          :rules="[required]"
                          dense
                          outlined
                          hide-details="auto"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-select
                          v-model="runCredit.coBorrower.currentResidence.state"
                          :items="$store.state.selectList.state"
                          item-text="displayName"
                          item-value="key"
                          label="State"
                          :rules="[requiredNotAllowZero]"
                          outlined
                          dense
                          hide-details="auto"
                          clearable
                        ></v-select>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field
                          label="Zipcode"
                          v-model="runCredit.coBorrower.currentResidence.zip"
                          :rules="[required, zipcode]"
                          dense
                          outlined
                          hide-details="auto"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field
                          label="SSN"
                          v-model="runCredit.coBorrower.ssn"
                          v-mask="$store.state.mask.ssn"
                          :rules="[required, ssn]"
                          readonly
                          background-color="readonly"
                          dense
                          outlined
                          hide-details="auto"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field
                          label="Day of Birth (yyyy-mm-dd)"
                          v-model="runCredit.coBorrower.dob"
                          v-mask="$store.state.mask.date2"
                          :rules="[required]"
                          dense
                          outlined
                          hide-details="auto"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-select
                          label="Marital Status"
                          v-model="runCredit.coBorrower.maritalStatus"
                          :items="maritalStatusItems"
                          item-text="displayName"
                          item-value="codeValue"
                          :rules="[requiredNotAllowZero]"
                          dense
                          outlined
                          hide-details="auto"
                        ></v-select>
                      </v-col>
                    </v-row>
                  </v-sheet>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" elevation="0" @click="submitCreditReport">
                Run {{ runCredit.creditRequestType }} Credit Report
              </v-btn>
              <v-btn @click="runCredit.dialog = false" text> Close </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogEmployer.show" max-width="700" persistent>
        <v-form ref="employerForm" v-if="!!dialogEmployer.tempEmployer">
          <v-card>
            <v-card-title class="text-body-1 grey lighten-2">
              <div>Update Employer</div>
              <v-spacer></v-spacer>
              <v-btn @click="dialogEmployer.show = false" x-small icon light>
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <br />
                  <v-select
                    v-if="dialogEmployer.tempEmployer.status != 2"
                    label="Status"
                    v-model="dialogEmployer.tempEmployer.status"
                    :items="
                      $store.state.byteProEnumList.employerStatus.filter(
                        (x) => x.key != 2
                      )
                    "
                    item-text="displayName"
                    item-value="key"
                    :rules="[required]"
                    dense
                    hide-details="auto"
                    clearable
                  ></v-select>
                  <v-select
                    v-else
                    label="Status"
                    v-model="dialogEmployer.tempEmployer.status"
                    :items="$store.state.byteProEnumList.employerStatus"
                    item-text="displayName"
                    item-value="key"
                    disabled
                    dense
                    hide-details="auto"
                    clearable
                  ></v-select>
                </v-col>
                <v-col cols="12"
                  ><div>
                    <v-text-field
                      label="Employer"
                      v-model="dialogEmployer.tempEmployer.name"
                      :rules="[required]"
                      dense
                      hide-details="auto"
                      clearable
                    ></v-text-field></div
                ></v-col>
                <v-col cols="12" md="12"
                  ><div>
                    <v-text-field
                      label="Street"
                      v-model="dialogEmployer.tempEmployer.street"
                      :rules="[required]"
                      dense
                      hide-details="auto"
                      clearable
                    ></v-text-field></div
                ></v-col>
                <v-col cols="12" md="4"
                  ><div>
                    <v-text-field
                      label="City"
                      v-model="dialogEmployer.tempEmployer.city"
                      :rules="[required]"
                      dense
                      hide-details="auto"
                      clearable
                    ></v-text-field></div
                ></v-col>
                <v-col cols="12" md="4"
                  ><div>
                    <v-select
                      label="State"
                      v-model="dialogEmployer.tempEmployer.state"
                      :items="$store.state.selectList.state"
                      item-text="displayName"
                      item-value="key"
                      :rules="[requiredNotAllowZero]"
                      dense
                      hide-details="auto"
                      clearable
                    ></v-select></div
                ></v-col>
                <v-col cols="12" md="4"
                  ><div>
                    <v-text-field
                      label="Zip"
                      v-model="dialogEmployer.tempEmployer.zip"
                      :rules="[required, zipcode]"
                      dense
                      hide-details="auto"
                      clearable
                    ></v-text-field></div
                ></v-col>
                <v-col cols="12" md="6"
                  ><div>
                    <v-text-field
                      label="Phone"
                      v-model="dialogEmployer.tempEmployer.phone"
                      :messages="
                        dialogEmployer.tempEmployer.phone
                          | VMask($store.state.mask.phone)
                      "
                      :rules="[number]"
                      dense
                      hide-details="auto"
                      clearable
                    ></v-text-field></div
                ></v-col>
                <v-col cols="12" md="6"
                  ><div>
                    <v-text-field
                      label="Fax"
                      v-model="dialogEmployer.tempEmployer.fax"
                      :messages="
                        dialogEmployer.tempEmployer.fax
                          | VMask($store.state.mask.phone)
                      "
                      :rules="[number]"
                      dense
                      hide-details="auto"
                      clearable
                    ></v-text-field>
                  </div>
                </v-col>
                <v-col cols="12" md="6"
                  ><div>
                    <v-text-field
                      label="Email"
                      v-model="dialogEmployer.tempEmployer.email"
                      :rules="[email]"
                      dense
                      hide-details="auto"
                      clearable
                    ></v-text-field></div
                ></v-col>
                <v-col cols="12" md="6"
                  ><div>
                    <v-text-field
                      label="Attention"
                      v-model="dialogEmployer.tempEmployer.attn"
                      dense
                      hide-details="auto"
                      clearable
                    ></v-text-field></div
                ></v-col>
                <v-col cols="12" md="6">
                  <div>
                    <v-select
                      label="Time In line of work (Years)"
                      v-model="
                        dialogEmployer.tempEmployer.timeInLineOfWorkYears
                      "
                      :items="Array.from({ length: 51 }, (_, index) => index)"
                      dense
                      hide-details="auto"
                    ></v-select>
                  </div>
                </v-col>
                <v-col cols="12" md="6">
                  <v-select
                    label="Time In line of work (Months)"
                    v-model="dialogEmployer.tempEmployer.timeInLineOfWorkMonths"
                    :items="Array.from({ length: 13 }, (_, index) => index)"
                    dense
                    hide-details="auto"
                  ></v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <div>
                    <v-menu
                      v-model="dialogEmployer.tempEmployer.dateFromMenu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="dialogEmployer.tempEmployer.dateFrom"
                          :rules="[required]"
                          label="Start Date"
                          append-icon="mdi-calendar"
                          clearable
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="dialogEmployer.tempEmployer.dateFrom"
                        @input="
                          dialogEmployer.tempEmployer.dateFromMenu = false
                        "
                      ></v-date-picker>
                    </v-menu>
                  </div>
                </v-col>
                <v-col cols="12" md="6">
                  <div v-if="dialogEmployer.tempEmployer.status != 2">
                    <v-menu
                      v-model="dialogEmployer.tempEmployer.dateToMenu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="dialogEmployer.tempEmployer.dateTo"
                          :rules="[required]"
                          label="End Date"
                          append-icon="mdi-calendar"
                          readonly
                          clearable
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="dialogEmployer.tempEmployer.dateTo"
                        @input="dialogEmployer.tempEmployer.dateToMenu = false"
                      ></v-date-picker>
                    </v-menu>
                  </div>
                </v-col>
                <v-col cols="12"
                  ><div>
                    <v-textarea
                      label="Notes"
                      v-model="dialogEmployer.tempEmployer.notes"
                      dense
                      hide-details="auto"
                      outlined
                      clearable
                    ></v-textarea></div
                ></v-col>
              </v-row>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-btn
                v-if="dialogEmployer.tempEmployer.employerId > 0"
                color="error"
                elevation="0"
                @click="deleteEmployer"
              >
                Delete
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                outlined
                elevation="0"
                @click="dialogEmployer.show = false"
              >
                Close
              </v-btn>
              <v-btn
                v-if="dialogEmployer.tempEmployer.employerId > 0"
                color="primary"
                elevation="0"
                @click="updateEmployer"
              >
                Update
              </v-btn>

              <v-btn v-else color="primary" elevation="0" @click="addEmployer">
                Add
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>

      <v-dialog v-model="importDebt.dialogDebt" max-width="1400" persistent>
        <v-card>
          <v-card-title class="text-body-1 grey lighten-2">
            <div>{{ importDebt.nameOnReport }}</div>
            <v-spacer></v-spacer>
            <v-btn @click="importDebt.dialogDebt = false" x-small icon light>
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <div class="text-h6 success--text">
                  Liabilities to be used in Runding DU
                </div>
                <v-sheet outlined>
                  <v-form ref="debtForm">
                    <v-simple-table dense height="550">
                      <template v-slot:default>
                        <thead class="lightgrey">
                          <tr>
                            <th class="text-left overflow-ellipsis">
                              Account #
                            </th>
                            <th class="text-left overflow-ellipsis">Type</th>
                            <th
                              class="text-left overflow-ellipsis"
                              style="width: 130px"
                            >
                              Name
                            </th>
                            <th class="text-left overflow-ellipsis">
                              Unpaid Bal
                            </th>
                            <th class="text-left overflow-ellipsis">
                              Mo. Payment
                            </th>
                            <th class="text-left overflow-ellipsis">Left</th>
                            <th class="text-left overflow-ellipsis">Held</th>
                            <th class="text-left overflow-ellipsis">
                              Borrower
                            </th>
                            <th class="text-left overflow-ellipsis">
                              Linked REO
                            </th>

                            <th class="text-left overflow-ellipsis">
                              Mortgage Type
                            </th>
                            <th>
                              <div class="overflow-ellipsis">
                                Omitted | To be Paid Off | Resubordinated | Not
                                Counted
                              </div>
                            </th>
                          </tr>
                        </thead>
                        <tbody
                          v-if="
                            !!importDebt.debtsFromOriginal &&
                            importDebt.debtsFromOriginal.length > 0
                          "
                        >
                          <tr
                            v-for="(
                              debt, index
                            ) in importDebt.debtsFromOriginal"
                            :key="
                              debt.debtId +
                              '-' +
                              debt.creditLiabilityID +
                              '-' +
                              index
                            "
                            :class="index % 2 ? 'lightgrey' : ''"
                          >
                            <td>
                              <v-icon
                                v-if="debt.debtId == 0"
                                color="success"
                                small
                                >mdi-new-box</v-icon
                              >{{ debt.accountNo }}
                            </td>
                            <td>
                              {{
                                $store.state.mstCodeEnums[
                                  `debtType${debt.debtType}`
                                ]
                              }}
                            </td>
                            <td :title="debt.name">
                              <div class="overflow-ellipsis">
                                {{ `${debt.name}` }}
                              </div>
                            </td>
                            <td>{{ debt.unpaidBal | currency("$", 2, 1) }}</td>
                            <td>{{ debt.moPayment | currency("$", 2, 1) }}</td>
                            <td>{{ debt.paymentsLeft }}</td>
                            <td>
                              {{
                                debt.accountHeldByType == 1
                                  ? "Jointly"
                                  : "Individually"
                              }}
                            </td>
                            <td>
                              <v-select
                                label="Borrower Name"
                                v-model="debt.borrowerId"
                                :items="importDebt.borrowers"
                                item-text="firstName"
                                item-value="borrowerId"
                                :rules="[requiredNotAllowZero]"
                                outlined
                                hide-details="auto"
                                dense
                                style="width: 150px"
                              ></v-select>
                            </td>
                            <td>
                              <div v-if="[3, 4].includes(debt.debtType)">
                                <v-select
                                  label="Real estate owned"
                                  v-model="debt.reoid"
                                  :items="
                                    fileData.reos.filter(
                                      (x) => x.borrowerId == debt.borrowerId
                                    )
                                  "
                                  :item-text="
                                    (item) =>
                                      `${item.street}, ${item.city}, ${item.state} ${item.zip}`
                                  "
                                  item-value="reoid"
                                  :rules="[requiredNotAllowZero]"
                                  outlined
                                  hide-details="auto"
                                  dense
                                  style="width: 200px"
                                ></v-select>
                              </div>
                            </td>
                            <td>
                              <div v-if="[3, 4].includes(debt.debtType)">
                                <v-select
                                  label="Mortgage Type"
                                  v-model="debt.mortgageType"
                                  :items="
                                    $store.state.byteProEnumList.mortgageType.filter(
                                      (x) => [1, 2, 3, 5].includes(x.key)
                                    )
                                  "
                                  item-text="displayName"
                                  item-value="key"
                                  :rules="[requiredNotAllowZero]"
                                  outlined
                                  hide-details="auto"
                                  dense
                                  style="width: 200px"
                                  clearable
                                ></v-select>
                              </div>
                            </td>

                            <td>
                              <div class="d-flex">
                                <v-checkbox
                                  v-model="debt.omitted"
                                  dense
                                  hide-details="auto"
                                  class="mx-3"
                                  color="error"
                                  title="Omitted"
                                />
                                <v-checkbox
                                  v-model="debt.toBePaidOff"
                                  dense
                                  hide-details="auto"
                                  color="warning"
                                  class="mx-6"
                                  title="To be Paid Off"
                                />
                                <v-checkbox
                                  v-model="debt.resubordinated"
                                  dense
                                  hide-details="auto"
                                  class="mx-8"
                                  title="Resubordinated"
                                />
                                <v-checkbox
                                  v-model="debt.notCounted"
                                  dense
                                  hide-details="auto"
                                  class="mx-3"
                                  title="Not Counted"
                                  color="default"
                                />
                              </div>
                            </td>
                          </tr>
                        </tbody>
                        <tbody v-else>
                          <tr>
                            <td colspan="11" class="text-center error--text">
                              Data not found.
                            </td>
                          </tr>
                          <tr>
                            <td colspan="11" class="text-center">
                              <v-btn
                                class="my-2"
                                color="info"
                                outlined
                                elevation="0"
                                @click="
                                  pullDebtData(
                                    fileData.fileDataId,
                                    importDebt.borrowerId
                                  )
                                "
                                >Import data from borrower's credit
                                report</v-btn
                              >
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-form>
                </v-sheet>
              </v-col>
              <v-col cols="12" class="text-right">
                <v-btn
                  color="primary"
                  elevation="0"
                  @click="submitImportDebt(true)"
                >
                  Confirm
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-model="linkedDebtDialog.show" max-width="1200" persistent>
        <v-card-title class="text-body-1 grey lighten-2">
          <div>
            Link liabilities - {{ linkedDebtDialog?.borrower?.fullName }}
          </div>
          <v-spacer></v-spacer>
          <v-btn @click="linkedDebtDialog.show = false" x-small icon light>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card>
          <v-simple-table dense>
            <template v-slot:default>
              <thead class="lightgrey">
                <tr>
                  <th class="text-left overflow-ellipsis">Selected</th>
                  <th class="text-left overflow-ellipsis">Account #</th>
                  <th class="text-left overflow-ellipsis">Type</th>
                  <th class="text-left overflow-ellipsis" style="width: 130px">
                    Name
                  </th>
                  <th class="text-left overflow-ellipsis">Unpaid Bal</th>
                  <th class="text-left overflow-ellipsis">Mo. Payment</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="debt in linkedDebtDialog.debts.filter(
                    (x) =>
                      x.borrowerId == linkedDebtDialog.borrower.borrowerId &&
                      (x.reoid == null || x.reoid == 0) &&
                      (x.debtType == 3 || x.debtType == 4)
                  )"
                  :key="`not-assgined-debt-` + debt.debtId"
                >
                  <td>
                    <div class="d-flex">
                      <v-checkbox
                        v-model="linkedDebtDialog.selected"
                        :value="debt.debtId"
                        dense
                        hide-details="auto"
                        class="mx-3"
                        color="primary"
                      />
                    </div>
                  </td>
                  <td>
                    <v-icon v-if="debt.debtId == 0" color="success" small
                      >mdi-new-box</v-icon
                    >{{ debt.accountNo }}
                  </td>
                  <td>
                    {{ $store.state.mstCodeEnums[`debtType${debt.debtType}`] }}
                  </td>
                  <td :title="debt.name">
                    <div class="overflow-ellipsis">
                      {{ `${debt.name}` }}
                    </div>
                  </td>
                  <td>{{ debt.unpaidBal | currency("$", 2, 1) }}</td>
                  <td>{{ debt.moPayment | currency("$", 2, 1) }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              outlined
              elevation="0"
              @click="resetLinkedDebtDialog"
            >
              Close
            </v-btn>
            <v-btn color="primary" elevation="0" @click="linkDebtToREO">
              Link
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <div v-else>
      <div>Error</div>
    </div>
    <LoanDetailSubMenu />
  </v-container>
</template>

<script>
import QuickNavigation from "@/components/QuickNavigation";
import LoanDetailSubMenu from "@/components/LoanDetailSubMenu";
import { rules, convert, common } from "@/mixins";
import vueDropzone from "vue2-dropzone";

export default {
  name: "FannieMae",
  components: {
    QuickNavigation,
    LoanDetailSubMenu,
    vueDropzone,
  },
  async mounted() {
    await this.initDU();
  },
  watch: {
    step: async function (s) {
      if (s == 1) {
        //TODO
      } else if (s == 2) {
        this.du.importDebtStatus = [];
        this.fileData.applications.forEach((app) => {
          this.du.importDebtStatus.push({
            applicationId: app.applicationId,
            borrowerId: app.borrowerId,
            nameOnReport: this.getNameOnReport(app),
            checked: false,
          });
        });

        //TODO
      } else if (s == 3) {
        // TODO
      } else if (s == 4) {
        // STEP 4: Desktop Underwriter
        if (this.fileData.fannie.caseFileId == 0) {
          this.fileData.fannie.caseFileId = null;
        }
      }
    },
    selectedCreditAgency: async function (agency) {
      try {
        for (let i = 0; i < this.du.credits.length; i++) {
          const customValue = this.fileData.customValues.find(
            (x) =>
              x.name ==
              `${agency.codeName}.CreditRefNo.${this.du.credits[
                i
              ].borrowerSSN.replace(/-/g, "")}`
          );

          this.du.credits[i].creditRefNo = customValue?.value;
          this.du.credits[i].codeName = agency.codeName;
          this.du.credits[i].creditProvider = agency.displayName;
          this.du.credits[i].creditProviderId = Number(agency.codeValue);
        }

        this.fileData.fannie.creditAgencyCode = agency.codeValue;
      } catch (e) {
        this.$store.commit("statusDialog/showErrorDialog", e);
      }
    },
  },
  data() {
    return {
      loading: true,
      fileData: null,
      logResp: null,
      step: 1,
      creditReportEmbeddedDocTypes: [73, 284, 484, 494, 625],
      creditAgencies: [],
      creditProviders: [],
      maritalStatusItems: [],
      selectedCreditAgency: {},
      createdDebts: [],
      tempBorrowerId: null,
      dialogEmployer: {
        show: false,
        tempEmployer: null,
      },
      du: {
        step: 1,
        creditProvider: null,
        credits: [],
        importDebtStatus: [],
        run: {
          validate: false,
        },
        result: null,
      },
      importDebt: {
        dialogDebt: false,
        creditReportEmbeddedDocId: null,
        borrowerId: null,
        coBorrowerId: null,
        borrowers: [],
        debtsFromCreditReport: [],
        debtsFromOriginal: [],
        hideItemsWithZeroBalance: false,
        nameOnReport: null,
      },
      runCredit: {
        dialog: false,
        applicationId: null,
        borrower: null,
        coBorrower: null,
        customValueId: 0,
        creditProvider: null,
        creditProviderId: null,
        creditRefNo: null,
        codeName: null,
        creditRequestType: null,
        hasCreditReferenceNo: false,
      },
      linkedDebtDialog: {
        show: false,
        reoId: null,
        borrower: null,
        selected: [],
      },
      creditReportOptions: [],
      bcaFormDropzoneOptions: {
        acceptedFiles: "application/pdf",
        url: `${process.env.VUE_APP_API_BASE_URL}/api/BytePro/EmbeddedDoc/Dropzone`,
        headers: { Authorization: `Bearer ${this.$store.state.token}` },
        thumbnailWidth: 200,
        addRemoveLinks: true,
        maxFiles: 4,
        maxFilesize: 50, // 100 MB
        autoProcessQueue: false,
        uploadMultiple: true,
        paramName: () => "files",
        dictDefaultMessage:
          "<p class='text-h6'>Please drag & drop here Signed borrower certification & authorization form forms </p><p class='text-hsubtitle-1'>(You may upload up to 4 files)</p>",
      },
      dropzoneDocs: [],
    };
  },
  methods: {
    async initDU() {
      this.loading = true;
      this.creditAgencies = await this.$store
        .dispatch("lookUpApi/getMstCodeVM", "CreditAgency")
        .then((resp) =>
          resp
            .filter((x) => !x.isDisabled)
            .sort((a, b) => a.displayName.localeCompare(b.displayName))
        )
        .catch(() => []);

      this.maritalStatusItems = await this.$store
        .dispatch("lookUpApi/getMstCodeVM", "MaritalStatus")
        .then((resp) => resp)
        .catch(() => []);

      this.fileData = await this.$store
        .dispatch("fileDataApi/getFileDataDetail", {
          loanNumber: this.$route.query.loanNumber,
          option: "AllWithOutEmbeddedDocs",
        })
        .then((resp) => resp.data)
        .catch(() => null);

      // is not prospect
      if (this.fileData.status.loanStatus != 11) {
        this.$store.commit("statusDialog/show", {
          type: "warning",
          message:
            "This feature is available only when it is in the Prospect loan status.",
          width: 800,
        });
        this.$router.go(-1);
      }

      this.fileData.embeddedDocs = await this.$store
        .dispatch("embeddeddoc/get", {
          fileDataId: this.fileData.fileDataId,
        })
        .then((resp) => resp.data)
        .catch(() => null);

      this.fileData.fannie = await this.$store
        .dispatch("fannie/get", this.fileData.fileDataId)
        .then((resp) => resp.data)
        .catch(() => null);

      // check credit ref number & report xml
      // console.log(this.fileData.fannie);

      this.logResp = await this.$store
        .dispatch("logDesktopUnderwriting/get", this.fileData.fileDataId)
        .then((resp) => resp.data)
        .catch(() => null);

      if (this.logResp == null) {
        this.logResp = await this.$store
          .dispatch("logDesktopUnderwriting/create", this.fileData.fileDataId)
          .then((resp) => resp.data)
          .catch(() => null);
      }

      this.du = JSON.parse(this.logResp.dataJson);

      if (this.du == null) {
        this.du = {
          step: 1,
          credits: [],
          importDebtStatus: [],
          run: {
            validate: false,
          },
          result: null,
        };
      }

      this.fileData.applications.forEach((app) => {
        const nameOnReport = this.getNameOnReport(app);

        this.du.credits.push({
          applicationId: app.applicationId,
          borrowerId: app.borrowerId,
          borrowerSSN: app.borrower.ssn,
          coBorrowerId: app.coBorrowerId,
          // coBorrowerSSN: app.coBorrower?.ssn,
          nameOnReport: nameOnReport,
          creditReportXml: this.fileData.embeddedDocs.find(
            (x) =>
              (x.nameOnReport + "").toUpperCase() ==
                nameOnReport.toUpperCase() &&
              (x.fileExtension + "").toUpperCase() == "XML"
          ),
          creditReportPdf: this.fileData.embeddedDocs.find(
            (x) =>
              x.documentTypeCode == "CreditReport" &&
              (x.nameOnReport + "").toUpperCase() ==
                nameOnReport.toUpperCase() &&
              (x.fileExtension + "").toUpperCase() == "PDF"
          ),
        });
      });

      this.creditProviders = await this.$store
        .dispatch("credit/getCreditProviders", this.fileData.fileDataId)
        .then((resp) => resp.data)
        .catch(() => []);

      this.du.creditProvider = this.creditProviders[1];
      const brokerInfo = await this.$store
        .dispatch(
          "mstBrokerApi/getOne",
          this.$store.state.userOrgProfile.organizationId
        )
        .then((resp) => resp.data)
        .catch(() => null);

      this.creditReportOptions = [
        {
          codeValue: "Reissue",
          displayName: "Re-issue Existing Report",
        },
      ];

      if (!!brokerInfo && brokerInfo.creditOrderPermission == "Y") {
        this.creditReportOptions.push({
          codeValue: "Submit",
          displayName: "Issue a New Report",
        });
      }

      // const creditReports = this.fileData.embeddedDocs.filter((x) => x.documentTypeCode == "CreditReport");

      // if(creditReports != null){
      //   creditReports.forEach(credit => {
      //     console.log(credit.description + " | " + credit.fileExtension + " | " + credit.nameOnReport);
      //   });
      // }

      // console.log(
      //   this.fileData.embeddedDocs.filter(
      //     (x) => x.documentTypeCode == "CreditReport" && x.fileExtension == "PDF"
      //   )
      // );

      this.loading = false;
    },

    resetLinkedDebtDialog() {
      this.linkedDebtDialog.show = false;
      this.linkedDebtDialog.reoId = null;
      this.linkedDebtDialog.borrower = null;
      this.linkedDebtDialog.selected = [];
    },
    async showEmbeddedDoc(embeddedDoc) {
      this.$store.commit("setGlobalLoading", true);
      try {
        const doc = await this.$store
          .dispatch("embeddeddoc/getOne", {
            fileDataId: embeddedDoc.fileDataId,
            embeddedDocId: embeddedDoc.embeddedDocId,
          })
          .then((resp) => resp.data)
          .catch(() => null);

        this.openPdfNewTabWithBase64(doc.documentData, doc.description);
      } catch (e) {
        this.$store.commit("statusDialog/showErrorDialog", e);
      }
      this.$store.commit("setGlobalLoading", false);
    },
    async showCreditSubmitForm(applicationId) {
      this.$store.commit("setGlobalLoading", true);
      try {
        if (!this.du.creditProvider) {
          throw new Error("Please select credit agency");
        }

        const app = this.fileData.applications.find(
          (x) => x.applicationId == applicationId
        );

        const creditRefNo = this.fileData.customValues.find((x) =>
          x.name.includes(
            `${this.selectedCreditAgency.codeName}.CreditRefNo.${app.borrower.ssn}`
          )
        );

        const selectedCreditAgency = this.du.credits.find(
          (x) => x.codeName == this.selectedCreditAgency.codeName
        );

        this.runCredit.applicationId = app.applicationId;
        this.runCredit.fileDataId = app.fileDataId;
        this.runCredit.hasCreditReferenceNo = !!creditRefNo;
        this.runCredit.creditRefNo = creditRefNo?.value;
        this.runCredit.customValueId = creditRefNo?.customValueId;
        this.runCredit.borrower = app.borrower;
        this.runCredit.coBorrower = app.coBorrower;
        this.runCredit.codeName = selectedCreditAgency.codeName;
        this.runCredit.creditProviderId = selectedCreditAgency.creditProviderId;
        this.runCredit.creditProvider = selectedCreditAgency.creditProvider;

        this.runCredit.dialog = true;
      } catch (e) {
        this.$store.commit("statusDialog/showErrorDialog", e);
      }
      this.$store.commit("setGlobalLoading", false);
    },
    async showImportLiabilities(nameOnReport, applicationId) {
      this.$store.commit("setGlobalLoading", true);
      try {
        const creditReportEmbeddedDoc = this.fileData.embeddedDocs.findLast(
          (x) =>
            (x.nameOnReport + "").toUpperCase() == nameOnReport.toUpperCase() &&
            (x.fileExtension + "").toUpperCase() == "XML" &&
            ((x.description + "")
              .toUpperCase()
              .startsWith(this.selectedCreditAgency.codeName.toUpperCase()) ||
              (x.description + "")
                .toUpperCase()
                .startsWith(
                  this.selectedCreditAgency.displayName.toUpperCase()
                ))
        );

        if (creditReportEmbeddedDoc == null) {
          throw new Error("Credit Report not found");
        }

        const debtsInCreditReport = await this.$store
          .dispatch("debtApi/parseCreditReport", {
            fileDataId: this.fileData.fileDataId,
            embeddedDocId: creditReportEmbeddedDoc.embeddedDocId,
          })
          .catch((err) => err);

        if (debtsInCreditReport.status != 200) {
          throw new Error(debtsInCreditReport.data);
        } else {
          this.importDebt.debtsFromCreditReport = debtsInCreditReport.data;
        }

        const app = this.fileData.applications.find(
          (x) => x.applicationId == applicationId
        );
        this.importDebt.debtsFromOriginal = [];

        const debtsInSystemForBorrower = await this.$store
          .dispatch("debtApi/get", app.borrowerId)
          .catch((err) => err);

        if (debtsInSystemForBorrower.status != 200) {
          throw new Error(debtsInSystemForBorrower.data);
        }

        if (app.coBorrowerId != null) {
          const debtsInSystemForCoBorrower = await this.$store
            .dispatch("debtApi/get", app.coBorrowerId)
            .catch((err) => err);

          if (debtsInSystemForCoBorrower.status != 200) {
            throw new Error(debtsInSystemForCoBorrower.data);
          }

          if (
            debtsInSystemForBorrower.data != null &&
            debtsInSystemForCoBorrower.data != null
          ) {
            this.importDebt.debtsFromOriginal =
              this.importDebt.debtsFromOriginal.concat(
                debtsInSystemForBorrower.data,
                debtsInSystemForCoBorrower.data
              );
          } else if (debtsInSystemForBorrower.data != null) {
            this.importDebt.debtsFromOriginal =
              this.importDebt.debtsFromOriginal.concat(
                debtsInSystemForBorrower.data
              );
          }
        }

        if (app.borrower != null) {
          this.importDebt.borrowers = [app.borrower];
        }
        if (app.coBorrower != null) {
          this.importDebt.borrowers.push(app.coBorrower);
        }

        this.importDebt.borrowerId = app.borrowerId;
        this.importDebt.coBorrowerId = app.coBorrowerId;
        this.importDebt.nameOnReport = nameOnReport;

        this.importDebt.dialogDebt = true;
      } catch (e) {
        this.$store.commit("statusDialog/showErrorDialog", e);
      }
      this.$store.commit("setGlobalLoading", false);
    },
    async showLinkLiabilities(reoId, borrower) {
      this.linkedDebtDialog.reoId = reoId;
      this.linkedDebtDialog.borrower = borrower;
      this.linkedDebtDialog.show = true;
      this.linkedDebtDialog.selected = [];
    },
    async linkDebtToREO() {
      this.$store.commit("setGlobalLoading", true);
      try {
        var selectedDebtIdSet = new Set(this.linkedDebtDialog.selected);
        var selectedDebts = this.fileData.debts.filter((x) =>
          selectedDebtIdSet.has(x.debtId)
        );

        selectedDebts.forEach((debt) => {
          debt.reoid = this.linkedDebtDialog.reoId;
        });

        const resp = await this.$store
          .dispatch("debtApi/update", {
            borrowerId: this.linkedDebtDialog.borrower.borrowerId,
            debts: selectedDebts,
          })
          .catch((err) => err);

        if (resp.status > 200) {
          throw resp.data;
        }

        this.resetLinkedDebtDialog();

        this.$store.commit(
          "statusDialog/showSuccessDialog",
          "Congratulations, Your request has been successfully executed."
        );
      } catch (e) {
        selectedDebts.forEach((debt) => {
          debt.reoid = null;
        });
        this.resetLinkedDebtDialog();
        this.$store.commit("statusDialog/showErrorDialog", e);
      }
      this.$store.commit("setGlobalLoading", false);
    },
    async addEmployer() {
      this.$store.commit("setGlobalLoading", true);
      try {
        if (this.$refs.employerForm.validate()) {
          const resp = await this.$store
            .dispatch("employerApi/add", {
              fileDataId: this.dialogEmployer.tempEmployer.fileDataId,
              borrowerId: this.dialogEmployer.tempEmployer.borrowerId,
              employers: [this.dialogEmployer.tempEmployer],
            })
            .catch((err) => err);

          if (resp.status > 200) {
            throw resp.data;
          }

          this.$store
            .dispatch(
              "employerApi/get",
              this.dialogEmployer.tempEmployer.fileDataId
            )
            .then((result) => {
              this.fileData.employers = result.data;
            });

          this.dialogEmployer.show = false;
        }
      } catch (error) {
        this.$store.commit("statusDialog/show", {
          type: "error",
          message: error,
          width: 800,
        });
      }

      this.$store.commit("setGlobalLoading", false);
    },
    async updateEmployer() {
      this.$store.commit("setGlobalLoading", true);
      try {
        if (this.$refs.employerForm.validate()) {
          const resp = await this.$store
            .dispatch("employerApi/update", {
              fileDataId: this.dialogEmployer.tempEmployer.fileDataId,
              employers: [this.dialogEmployer.tempEmployer],
            })
            .catch((err) => err);

          if (resp.status > 200) {
            throw resp.data;
          }

          this.$store
            .dispatch(
              "employerApi/get",
              this.dialogEmployer.tempEmployer.fileDataId
            )
            .then((result) => {
              this.fileData.employers = result.data;
            });

          this.dialogEmployer.show = false;
        }
      } catch (error) {
        this.$store.commit("statusDialog/show", {
          type: "error",
          message: error,
          width: 800,
        });
      }

      this.$store.commit("setGlobalLoading", false);
    },
    async deleteEmployer() {
      this.$store.commit("setGlobalLoading", true);
      try {
        const userConfirmed = await this.showConfirmDialog(
          "Are you sure delete this record?"
        );
        if (userConfirmed) {
          const resp = await this.$store
            .dispatch("employerApi/delete", {
              fileDataId: this.dialogEmployer.tempEmployer.fileDataId,
              borrowerId: this.dialogEmployer.tempEmployer.borrowerId,
              employerIds: [this.dialogEmployer.tempEmployer.employerId],
            })
            .catch((err) => err);

          if (resp.status > 200) {
            throw resp.data;
          }

          this.$store
            .dispatch(
              "employerApi/get",
              this.dialogEmployer.tempEmployer.fileDataId
            )
            .then((result) => {
              this.fileData.employers = result.data;
            });

          this.dialogEmployer.show = false;
        }
      } catch (error) {
        this.$store.commit("statusDialog/show", {
          type: "error",
          message: error,
          width: 800,
        });
      }

      this.$store.commit("setGlobalLoading", false);
    },

    // TODO Delete
    async submitCreditReport() {
      this.$store.commit("setGlobalLoading", true);
      try {
        const userConfirmed = await this.showConfirmDialog(
          "Do you want to get a credit report?"
        );
        if (this.$refs.runCreditForm.validate() && userConfirmed) {
          //#region 1. Borrower(CoBorrower) Information 업데이트
          let resp = await this.$store
            .dispatch("borrower/update", {
              fileDataId: this.fileData.fileDataId,
              borrower: this.runCredit.borrower,
            })
            .catch((err) => err);

          if (resp.status > 200) {
            throw new Error(resp.data);
          }

          if (this.runCredit.coBorrower != null) {
            resp = await this.$store
              .dispatch("borrower/update", {
                fileDataId: this.fileData.fileDataId,
                borrower: this.runCredit.coBorrower,
              })
              .catch((err) => err);

            if (resp.status > 200) {
              throw new Error(resp.data);
            }
          }
          //#endregion

          //#region 2. Residence Information 업데이트
          resp = await this.$store
            .dispatch("residence/update", {
              fileDataId: this.fileData.fileDataId,
              borrowerId: this.runCredit.borrower.borrowerId,
              residence: this.runCredit.borrower.currentResidence,
            })
            .catch((err) => err);

          if (resp.status > 200) {
            throw new Error(resp.data);
          }

          if (this.runCredit.coBorrower != null) {
            resp = await this.$store
              .dispatch("residence/update", {
                fileDataId: this.fileData.fileDataId,
                borrowerId: this.runCredit.coBorrower.borrowerId,
                residence: this.runCredit.coBorrower.currentResidence,
              })
              .catch((err) => err);

            if (resp.status > 200) {
              throw new Error(resp.data);
            }
          }
          //#endregion

          //#region 3. Custom Value 업데이트, Credit Number Information
          var creditCode = `${
            this.runCredit.codeName
          }.CreditRefNo.${this.runCredit?.borrower?.ssn?.replace(/-/g, "")}`;
          var creditInfo = this.fileData.customValues.find(
            (x) => x.name == creditCode
          );

          if (this.runCredit.creditRequestType === "Submit") {
            // delete
            if (creditInfo != undefined) {
              resp = await this.$store
                .dispatch("customValues/delete", {
                  customValueId: creditInfo.customValueId,
                })
                .catch((err) => err);

              if (resp.status > 200) {
                throw new Error(resp.data);
              }
            }
          } else if (this.runCredit.creditRequestType == "Reissue") {
            // Update
            if (creditInfo != undefined) {
              creditInfo.value = this.runCredit.creditRefNo;

              resp = await this.$store
                .dispatch("customValues/update", {
                  fileDataId: this.fileData.fileDataId,
                  customValues: [creditInfo],
                })
                .catch((err) => err);

              if (resp.status > 200) {
                throw new Error(resp.data);
              }
            } else {
              // create
              const customValues = [
                {
                  customValueId: 0,
                  fileDataId: this.fileData.fileDataId,
                  customValueType: 0,
                  name: `${this.runCredit.codeName}.CreditRefNo.${this.runCredit.borrower.ssn}`,
                  value: this.runCredit.creditRefNo,
                },
              ];

              resp = await this.$store
                .dispatch("customValues/create", {
                  fileDataId: this.fileData.fileDataId,
                  customValues: customValues,
                })
                .catch((err) => err);

              if (resp.status > 200) {
                throw new Error(resp.data);
              }
            }
          }
          //#endregion

          //#region 4. Run Credit Report
          resp = await this.$store
            .dispatch("credit/ordercredit", {
              ordercredit: this.runCredit,
              isImportDebts: true,
            })
            .catch((err) => err);

          if (resp.status > 200) {
            throw new Error(resp.data);
          }

          resp = await this.$store
            .dispatch("customValues/getAll", this.fileData.fileDataId)
            .catch((err) => err);

          // Sync Custom Values Field
          if (resp.status == 200) {
            this.fileData.customValues = resp.data;
          }

          this.du.credits.forEach((credit) => {
            const creditCode = `${credit.codeName}.CreditRefNo.${credit.borrowerSSN}`;

            const selectedCreditInfo = this.fileData.customValues.find(
              (x) => x.name === creditCode
            );

            credit.creditRefNo = selectedCreditInfo?.value;
            credit.codeName = this.selectedCreditAgency.codeName;
            credit.creditProvider = this.selectedCreditAgency.displayName;
            credit.creditProviderId = Number(
              this.selectedCreditAgency.codeValue
            );
          });

          this.fileData.debts = await this.$store
            .dispatch("debtApi/getAll", this.fileData.fileDataId)
            .then((resp) => resp.data)
            .catch(() => null);

          //#endregion

          //#region 5. Sync EmbeddedDoc
          this.fileData.embeddedDocs = await this.$store
            .dispatch("embeddeddoc/get", {
              fileDataId: this.fileData.fileDataId,
            })
            .then((resp) => resp.data)
            .catch(() => null);

          console.log(this.fileData.embeddedDocs);
          //#endregion

          this.runCredit.dialog = false;

          this.$store.commit(
            "statusDialog/showSuccessDialog",
            "Congratulations, you have successfully issued a credit report."
          );
        }
      } catch (e) {
        this.$store.commit("statusDialog/showErrorDialog", e);
      }

      this.$store.commit("setGlobalLoading", false);
    },
    async pullDebtData(fileDataId, borrowerId) {
      this.$store.commit("setGlobalLoading", true);

      const debts = await this.$store
        .dispatch("debtApi/overwriteDebtsCreditReport", {
          fileDataId: fileDataId,
          borrowerId: borrowerId,
        })
        .catch((err) => err);

      if (debts.status == 200) {
        this.importDebt.debtsFromOriginal = debts.data;
      }

      // const reos = await this.$store
      //   .dispatch("reoApi/getAll", fileDataId)
      //   .catch((err) => err);

      // if (reos.status == 200) {
      //   this.fileData.reos = reos.data;
      // }

      this.$store.commit("setGlobalLoading", false);
    },
    async submitImportDebt(isUpdate) {
      this.$store.commit("setGlobalLoading", true);
      try {
        if (this.$refs.debtForm.validate()) {
          if (isUpdate) {
            this.createdDebts = [];
            for (const borrower of this.importDebt.borrowers) {
              let newDebts = this.importDebt.debtsFromOriginal.filter(
                (debt) =>
                  debt.debtId == 0 && debt.borrowerId == borrower.borrowerId
              );

              newDebts = await this.$store
                .dispatch("debtApi/create", {
                  borrowerId: borrower.borrowerId,
                  debts: newDebts,
                })
                .then((resp) => resp.data)
                .catch(() => null);

              if (newDebts != null) {
                this.createdDebts = this.createdDebts.concat(newDebts);
              }

              let updatedDebts = this.importDebt.debtsFromOriginal.filter(
                (debt) =>
                  debt.debtId > 0 && debt.borrowerId == borrower.borrowerId
              );

              updatedDebts = await this.$store
                .dispatch("debtApi/update", {
                  borrowerId: borrower.borrowerId,
                  debts: updatedDebts,
                })
                .then((resp) => resp.data)
                .catch(() => null);
            }

            this.$store.commit(
              "statusDialog/showSuccessDialog",
              "Debt information has been updated."
            );
          }

          this.du.importDebtStatus.find(
            (x) => x.borrowerId == this.importDebt.borrowerId
          ).checked = true;

          this.fileData.debts = await this.$store
            .dispatch("debtApi/getAll", this.fileData.fileDataId)
            .then((resp) => resp.data)
            .catch(() => null);

          this.importDebt.dialogDebt = false;
        }
      } catch (e) {
        this.$store.commit("statusDialog/showErrorDialog", e);
      }
      this.$store.commit("setGlobalLoading", false);
    },
    async submitDU() {
      this.$store.commit("setGlobalLoading", true);
      try {
        const userConfirmed = await this.showConfirmDialog(
          "Do you want to run DU?"
        );
        if (this.$refs.submitDuForm.validate() && userConfirmed) {
          this.fileData.fannie = await this.$store
            .dispatch("fannie/update", this.fileData.fannie)
            .then((resp) => resp.data)
            .catch(() => null);

          const underwritingDU = {
            fileDataId: this.fileData.fileDataId,
            creditAgency: this.fileData.fannie.creditAgencyCode,
            creditAction:
              this.fileData.fannie.caseFileId != null
                ? "Reissue Report"
                : "Reissue Report",
          };

          const resp = await this.$store
            .dispatch("fannieMae/orderDU", underwritingDU)
            .catch((err) => err);

          if (resp.status > 200) throw new Error(resp.data);

          for (const item of this.createdDebts) {
            await this.$store.dispatch("debtApi/delete", item.debtId);
          }

          this.du.result = resp.data;

          this.step++;
        }
      } catch (error) {
        this.$store.commit("statusDialog/show", {
          type: "error",
          message: error,
          width: 800,
        });
      }
      this.$store.commit("setGlobalLoading", false);
    },
    async submitPackageVDropzoneSuccessMultiple(files, response) {
      this.$store.commit("setGlobalLoading", true);
      console.log("run: vdropzone-success-multiple");
      for (let i = 0; i < response.length; i++) {
        this.dropzoneDocs.push({
          fileDataId: this.fileData.fileDataId,
          documentTypeCode: "BorrowersCert",
          documentCategoryCode: "DISC",
          docStorageMethod: 1,
          viewable: true,
          fileExtension: "pdf",
          description: "BCA",
          path: response[i],
        });
      }
    },
    async submitPackageVDropzoneQueueCompleteMultiple() {
      console.log("run: vdropzone-queue-complete");
      if (this.dropzoneDocs.length > 0) {
        const resp = await this.$store
          .dispatch("embeddeddoc/create", {
            embeddedDocs: this.dropzoneDocs,
            loanNumber: this.fileData.fileName,
            notify: true,
          })
          .then((resp) => resp)
          .catch((err) => err);

        if (resp.status > 200) {
          this.$store.commit("statusDialog/showErrorDialog", resp.data);
        } else {
          resp.data.forEach((newDocs) => {
            this.fileData.embeddedDocs.push(newDocs);
          });
        }

        this.$refs.bcaFormDropzone.removeAllFiles();
        this.dropzoneDocs = [];
      }
      this.$store.commit("setGlobalLoading", false);
    },
    async submitPackageVDropzoneErrorMultiple(files, message) {
      console.log("run: vdropzone-error-multiple");
      this.$store.commit("statusDialog/showErrorDialog", message);
      this.$refs.bcaFormDropzone.removeAllFiles();
      this.$store.commit("setGlobalLoading", false);
    },
    async vdropzoneCompleteMultiple(response) {
      console.log("run: vdropzoneCompleteMultiple");
      console.log(response);
      this.$store.commit("setGlobalLoading", false);
    },
    async vdropzoneFileAdded(file) {
      console.log("run: vdropzoneFileAdded");
      if (file != null && file.size <= 0) {
        this.$refs.bcaFormDropzone.removeFile(file);
        this.$store.commit(
          "statusDialog/showErrorDialog",
          "A compressed file exists.🤐 <br />Please unzip and try again."
        );
      }
    },
    async downloadBCA() {
      this.$store.commit("setGlobalLoading", true);
      try {
        const bcaBase64 = await this.$store
          .dispatch("credit/getBCA", this.fileData.fileDataId)
          .then((resp) => resp.data)
          .catch(() => null);

        this.openPdfNewTabWithBase64(
          bcaBase64,
          "NewWaveLending Borrower Certification & Authorization Form"
        );
      } catch (err) {
        console.error(err);
      }

      this.$store.commit("setGlobalLoading", false);
    },
    downloadHtml(htmlContent) {
      // Blob 생성
      var blob = new Blob([htmlContent], { type: "text/html" });

      // 다운로드 링크 생성
      var a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = `DU_Findings_${this.fileData.fileName}_${this.fileData.applications[0].borrower.fullName}.html`;

      // 링크를 클릭하여 다운로드 시작
      a.click();
    },
    openFinding(htmlContent) {
      // PDF를 보여줄 객체 생성
      const blob = new Blob([htmlContent], { type: "text/html" });
      const url = URL.createObjectURL(blob);

      // 새로운 작은 윈도우 창 열기
      const newWindow = window.open("", "_blank", "width=1200,height=800");
      newWindow.document.title = `DU_Findings_${this.fileData.fileName}_${this.fileData.applications[0].borrower.fullName}.html`;

      // 새로운 작은 윈도우 창에 PDF를 보여줄 <embed> 요소 추가
      const pdfEmbed = document.createElement("embed");
      pdfEmbed.src = url;
      pdfEmbed.width = "100%";
      pdfEmbed.height = "100%";
      newWindow.document.body.appendChild(pdfEmbed);
    },
    showConfirmDialog(message) {
      return new Promise((resolve) => {
        // window.confirm 대신 사용자 정의 confirm을 만듦
        const userConfirmed = window.confirm(message);
        resolve(userConfirmed);
      });
    },
    showEmployerEditor(employer) {
      this.dialogEmployer.tempEmployer = { ...employer };
      if (this.dialogEmployer.tempEmployer.dateFrom != null) {
        this.dialogEmployer.tempEmployer.dateFrom = this.$moment(
          this.dialogEmployer.tempEmployer.dateFrom
        ).format("YYYY-MM-DD");
      }

      if (this.dialogEmployer.tempEmployer.dateTo != null) {
        this.dialogEmployer.tempEmployer.dateTo = this.$moment(
          this.dialogEmployer.tempEmployer.dateTo
        ).format("YYYY-MM-DD");
      }
      this.dialogEmployer.show = true;
    },
    getReoByBorrowerId(borrowerId) {
      const app = this.fileData.applications.find(
        (x) => x.borrowerId == borrowerId || x.coBorrowerId == borrowerId
      );

      return this.fileData.reos.filter(
        (x) =>
          x.borrowerId == app.borrowerId || x.borrowerId == app.coBorrowerId
      );
    },
  },
  mixins: [rules, convert, common],
};
</script>

<!-- 
  Step:
  1. Validate DU
    - if invalid, show error message
    - Broker correct information
  2. Check Credit Report
    - Select Credit Agency
    - Select Re-issue or New Report
    - If Re-issue, enter credit report number for each borrower
    - Enter Credit Agency Username and Password
    - Run Credit Report
  3. Liability swapping
    - Show Previous Liability and New Liability from Credit Report
    - Select Liability to swap
    - Update Liability
  4. Submit DU
  5. Review DU Result
 -->
